module.exports = __webpack_public_path__ + "static/media/vicon-slogan.bd805d4a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/vicon-slogan.png
// module id = 407
// module chunks = 2